import React, { Component } from 'react';

import Timer from './Timer.js';
import moment from 'moment';


class TimerContainer extends Component {
    constructor(props){
        super(props);
        this.state = {timerRunning:false, completeFactor: 0};
        this.tickDuration = 30;
        this.timerId = null;
        this.lastTickAt = null;
        this.msTotal = props.duration;
        this.msRemaining = this.msTotal;
        this.onComplete = this.onComplete.bind(this);
        this.tick = this.tick.bind(this);
    }
    componentWillReceiveProps(newProps) {
        if(newProps.run!==this.props.run) {
            if(newProps.run) {
                this.start();
            } else {
                this.stop();
            }
        }
    }
    componentWillMount() {
        if(this.props.run) {
            this.start();
        }
    }
    componentWillUnmount() {
        this.stop();
    }
    start() {
        if(this.timerId===null) {
            this.lastTickAt = new Date().getTime();
            this.timerId = setInterval(this.tick, this.tickDuration);
            this.setState({timerRunning:true});
        }
    }
    stop() {
        if(this.timerId) {
            clearInterval(this.timerId);
            this.timerId = null;
            this.setState({timerRunning:false});
        }
    }
    onComplete() {
        if(this.props.onComplete) {
            this.props.onComplete();
        }
    }
    tick() {
        var now = new Date().getTime();
        var ellapsed = now - this.lastTickAt;
        this.lastTickAt = now;
        this.msRemaining = Math.max(0,this.msRemaining - ellapsed);
        if(this.msRemaining == 0) {
            clearInterval(this.timerId);
            this.timerId = null;
            this.lastTickAt = null;
        }   
        var completeFactor = (1 - this.msRemaining / this.msTotal);
        this.setState({msRemaining:this.msRemaining, timerRunning:(this.timerId!=null), completeFactor:completeFactor});
            
        if(this.msRemaining == 0) {
            this.onComplete();
        }
    }

    computeSvgPath() {
        var x = 0, y = 0, r = 105, startAngle = 0;
        var endAngle = this.state.completeFactor * Math.PI * 2.0;
        var largeArc = endAngle - startAngle <= Math.PI ? 0 : 1;

        return ['M', x, y,
                'L', x+Math.cos(startAngle)*r, y-(Math.sin(startAngle)*r), 
                'A', r, r, 0, largeArc, 0, x+Math.cos(endAngle)*r, y-(Math.sin(endAngle)*r),
                'L', x, y
               ].join(' ');
    }

    render() {
        return <Timer formattedTimeLeft={moment.utc(this.state.msRemaining).format('mm:ss')} path={this.computeSvgPath()} />;
    }

}

export default TimerContainer;



// WEBPACK FOOTER //
// ./src/modules/challenges/types/TimerContainer.js